export const dateFormatWithTime = 'MM/DD/YYYY hh:mm A';

export const timeFormat = 'hh:mm A';

export const dateFormat = 'MM/DD/YYYY';

export const countryDateFormat = 'YYYY-MM-DD';

export const dateFormatSmallWithTime = 'MM/DD/YY hh:mm A';

export const dateTimeZoneFormat = 'MM/DD/YYYY Z';

export const monthFormat = 'MM/yyyy';

export const dateFormatForDayJs = 'YYYY-MM-DDTHH:mm:ss';

export const reportDateFormat = 'YYYYMMDDHHmmss';

export const ocrDateFormat = 'yy/MM/dd';